module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n3n4r8n-9f86d90ad7a81693c7bfc5e882409ca7.svg";